const deleteTechnicianUsecase = (repository) => async (id) => {
    return await repository(id);
}

export default deleteTechnicianUsecase;